/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../theme/css/select.css.ngstyle';
import * as i1 from '../../../../node_modules/select2/dist/css/select2.css.ngstyle';
import * as i2 from '../../../../node_modules/@swimlane/ngx-datatable/release/index.css.ngstyle';
import * as i3 from '../../../../node_modules/@swimlane/ngx-datatable/release/assets/icons.css.ngstyle';
import * as i4 from '../../../../node_modules/@swimlane/ngx-datatable/release/themes/material.css.ngstyle';
import * as i5 from '../../../../node_modules/@qontu/ngx-inline-editor/themes/bootstrap.css.ngstyle';
import * as i6 from '../../../../theme/css/datatable.css.ngstyle';
import * as i7 from '@angular/core';
import * as i8 from '../calculator.component.ngfactory';
import * as i9 from '../../../../../app/components/calculator/calculator.component';
import * as i10 from '../../../../../app/services/orderService';
import * as i11 from '@angular/router';
import * as i12 from '../../../../../app/services/extraDataService';
import * as i13 from '../../../../../app/services/publisher.service';
import * as i14 from './mobile/public-calculator-v2.component.ngfactory';
import * as i15 from '../../../../../app/components/calculator/public/mobile/public-calculator-v2.component';
import * as i16 from 'ngx-bootstrap/modal/bs-modal.service';
import * as i17 from '../../../../../app/services/google-tag.service';
import * as i18 from '@angular/common';
import * as i19 from '../../../../../app/components/calculator/public/public-calculator.component';
const styles_PublicCalculatorComponent:any[] = [i0.styles,i1.styles,i2.styles,i3.styles,
    i4.styles,i5.styles,i6.styles];
export const RenderType_PublicCalculatorComponent:i7.RendererType2 = i7.ɵcrt({encapsulation:2,
    styles:styles_PublicCalculatorComponent,data:{}});
function View_PublicCalculatorComponent_1(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[(_l()(),i7.ɵeld(0,(null as any),(null as any),4,'div',[['style',
      'margin-right:15px;margin-left:15px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i7.ɵted((null as any),[' '])),(_l()(),
      i7.ɵeld(0,(null as any),(null as any),1,'calculator',([] as any[]),(null as any),
          (null as any),(null as any),i8.View_CalculatorComponent_0,i8.RenderType_CalculatorComponent)),
      i7.ɵdid(114688,[[2,4],['publicCalculator',4]],0,i9.CalculatorComponent,[i10.OrderService,
          i11.ActivatedRoute,i12.ExtraDataService,i11.Router,i13.PublisherService],
          {order:[0,'order'],extraData:[1,'extraData'],isOrderDetails:[2,'isOrderDetails'],
              isPublic:[3,'isPublic'],mainElement:[4,'mainElement']},(null as any)),
      (_l()(),i7.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.order;
    const currVal_1:any = _co.extraData;
    const currVal_2:any = false;
    const currVal_3:any = true;
    const currVal_4:any = _co.publicPanelRef;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_PublicCalculatorComponent_2(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[(_l()(),i7.ɵeld(0,(null as any),(null as any),1,'public-calculator-v2',
      ([] as any[]),(null as any),[[(null as any),'restoreOrder']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('restoreOrder' === en)) {
          const pd_0:any = ((<any>_co.restoreOrder($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i14.View_PublicCalculatorV2Component_0,i14.RenderType_PublicCalculatorV2Component)),
      i7.ɵdid(114688,(null as any),0,i15.PublicCalculatorV2Component,[i11.Router,i11.ActivatedRoute,
          i16.BsModalService,i17.GoogleTagService],{order:[0,'order'],mainElement:[1,
          'mainElement']},{restoreOrder:'restoreOrder'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.order;
    const currVal_1:any = _co.publicPanelRef;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_PublicCalculatorComponent_0(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[i7.ɵqud(402653184,1,{publicPanelRef:0}),i7.ɵqud(671088640,2,{publicCalculator:0}),
      (_l()(),i7.ɵeld(0,[[1,0],['publicPanel',1]],(null as any),7,'div',[['class',
          'wrapper public-calc']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i7.ɵted((null as any),[' '])),(_l()(),i7.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PublicCalculatorComponent_1)),
      i7.ɵdid(16384,(null as any),0,i18.NgIf,[i7.ViewContainerRef,i7.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i7.ɵted((null as any),[' '])),(_l()(),
          i7.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PublicCalculatorComponent_2)),
      i7.ɵdid(16384,(null as any),0,i18.NgIf,[i7.ViewContainerRef,i7.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i7.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:i19.PublicCalculatorComponent = _v.component;
        const currVal_0:boolean = !_co.isV2;
        _ck(_v,5,0,currVal_0);
        const currVal_1:any = _co.isV2;
        _ck(_v,8,0,currVal_1);
      },(null as any));
}
export function View_PublicCalculatorComponent_Host_0(_l:any):i7.ɵViewDefinition {
  return i7.ɵvid(0,[(_l()(),i7.ɵeld(0,(null as any),(null as any),1,'public-calculator',
      ([] as any[]),(null as any),(null as any),(null as any),View_PublicCalculatorComponent_0,
      RenderType_PublicCalculatorComponent)),i7.ɵdid(4308992,(null as any),0,i19.PublicCalculatorComponent,
      [i7.Renderer2,i11.ActivatedRoute,i10.OrderService,i12.ExtraDataService,i11.Router],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PublicCalculatorComponentNgFactory:i7.ComponentFactory<i19.PublicCalculatorComponent> = i7.ɵccf('public-calculator',
    i19.PublicCalculatorComponent,View_PublicCalculatorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/calculator/public/public-calculator.component.ngfactory.ts